export class RightSideDrawerPayload {
    name: string;
    isOpen: boolean;
    data: any;
    drawerTitle: string;
}